import React, { createContext, useEffect, useState } from 'react';
import 'assets/styles/global.scss';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
// import ErrorPage from './pages/Error';
import styles from './App.module.scss';
import RootLayout from './pages/Root';
import PageTemplate from './pages/PageTemplate';
import { addCustomPathToLink } from '../functions';
// function BreadcrumbsRouter() {
//   const breadcrumbs = useBreadcrumbs(routes);
//   console.log(breadcrumbs)
//
//   return (
//     <nav>
//       {breadcrumbs.map(({ match, breadcrumb }) => (
//         <Link key={match.url} to={match.url}>
//           {breadcrumb} /
//         </Link>
//       ))}
//     </nav>
//   );
// }

function App() {
  const [jsonData, setJsonData] = useState(null);
  const [isJsonLoaded, setIsJsonLoaded] = useState(false);

  const apiLoader = (cat, path) => {
    // console.log(cat, path, jsonData[cat]);
    // fetch('data.json'
    //   ,{
    //     headers : {
    //       'Content-Type': 'application/json',
    //       'Accept': 'application/json'
    //     }
    //   }
    // )
    //   .then(function(response){
    //     // console.log(response)
    //     return response.json();
    //   })
    //   .then(function(myJson) {
    //     // console.log(myJson[cat].find((cat) => cat.slug == path));
    //     return [myJson[cat].find((cat) => cat.slug == path), myJson];
    //   });

    const foundSite = jsonData[cat].find((catTemp) => {
      // console.log('cat temp', catTemp.slug, path, addCustomPathToLink(catTemp.slug));
      return catTemp.slug == path || addCustomPathToLink(catTemp.slug) == path;
    });
    if (!foundSite) console.log('Page not found');

    return !!foundSite ? foundSite : !!jsonData[cat][0] ? jsonData[cat][0] : jsonData[cat][1];
  };

  const routes = [
    {
      path: process.env.PUBLIC_URL,
      element: <RootLayout json={jsonData} />,
      children: [
        { index: true, element: <PageTemplate />, loader: (_) => apiLoader('pages', '/') },
        {
          path: 'kategoria/:categorySlug',
          element: <PageTemplate />,
          loader: ({ params }) => apiLoader('categories', params.categorySlug),
        },
        {
          path: 'aranzacja/:subCatSlug',
          element: <PageTemplate />,
          loader: ({ params }) => apiLoader('subcategories', params.subCatSlug),
        },
        {
          path: ':slug',
          element: <PageTemplate />,
          loader: ({ params }) => apiLoader('pages', params.slug),
        },
      ],
    },
  ];

  const router = createBrowserRouter(routes);

  const fetchJson = async (_) => {
    // console.log('start fetch json');
    // console.log('https://cms.test.katalog.leroymerlin.pl/magazyn/public/api/katalog.json'); dla testowego
    // console.log('https://cms.katalog.leroymerlin.pl/magazyn/public/api/katalog.json'); dla katalogu
    // console.log('https://cms.katalog.leroymerlin.pl/magazyn/public/api/katalog_ogrod.json'); dla ogrodu
    //https://cms.katalog.leroymerlin.pl/magazyn/public/api/katalog_p2024.json
    // const response = await fetch('https://cms.katalog.leroymerlin.pl/magazyn/public/api/katalog_ogrod2025.json'
    //const response = await fetch('https://cms.katalog.leroymerlin.pl/magazyn/public/api/katalog_ogrod2025.json'

    const response = await fetch('https://cms.katalog.leroymerlin.pl/magazyn/public/api/katalog_projekty2025.json', {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      console.log('API error');
    } else {
      // console.log('fetch complete');
      return await response.json();
    }
  };

  useEffect((_) => {
    // console.log(process.env.PUBLIC_URL);

    fetchJson()
      .then((res) => {
        // console.log('json: ', res);
        setJsonData(res);
      })
      .then((_) => {
        setIsJsonLoaded(true);
      });
  }, []);

  return isJsonLoaded ? (
    <RouterProvider router={router} />
  ) : (
    <div className={styles.loadingOverlay}>
      <img className={styles.loadingLogo} src={'https://cms.katalog.leroymerlin.pl/magazyn/public/img/images/logo_LM.svg'}></img>
    </div>
  );
}

export default App;
